// 最低換金可能LIVEポイント
export const wisePayoutMinLivePoints = 5000
// 最大換金額可能LIVEポイント
export const wisePayoutMaxLivePoints = 500000

// デフォルト受取希望通貨
export const wiseDefaultPreferredCurrency = 'USD'

// 以下は受け取り希望通貨の定義リスト
export const wiseCurrencyList = ['USD', 'CAD', 'EUR', 'KRW', 'THB']
